import { combineReducers } from "redux"
import customizer from "./customizer/"
import auth from "./auth/"
import navbar from "./navbar/Index"
import form from "./form/"
import calenderReducer from "./calendar/"
import todoReducer from "./todo/"
import activityReducer from "./activity/"

const rootReducer = combineReducers({
  customizer: customizer,
  auth: auth,
  navbar: navbar,
  form: form,
  calendar: calenderReducer,
  todoApp: todoReducer,
  activity: activityReducer
})

export default rootReducer
